module.exports = __webpack_public_path__ + "img/menuIcon14.3defb4a3.png";